define('apps/classrooms/views/pdf-utils/generate-table-pdf-download',[
    "vendor/jspdf/jspdf",
    "vendor/jszip/jszip",
    "vendor/jszip-utils/jszip-utils",
    "vendor/jsfilesaver/jsfilesaver",
    "apps/classrooms/views/pdf-utils/common",
    "apps/classrooms/views/pdf-utils/pdf-mixin"
],
/*eslint strict: [0, "function"]*/
function(
    jspdf,
    JSZip,
    jsZipUtils,
    jsFilesaver,
    pdfCommonUtils,
    pdfMixin
) {
    /**
     * Takes a list of printable students and creates a PDF with
     *  a QR code and student details. For each PDF page, we display a 4 rows containing
     *  3 columns. After we have compiled all of the pages, create a PDF, and automatically
     *  prompt the pdf file download. This layout follows the following Address Label sticker
     *  paper, Avery 22806 Print-to-the-Edge Square Labels 2" x 2".
     */
    function buildTablePDF(targetStudents, isZip, zipFile, folderName) {
        var pdf = new jsPDF({ // eslint-disable-line new-cap
            "orientation": 'p',
            "unit": 'in',
            "format": 'letter',
        });

        var width = pdf.internal.pageSize.getWidth();
        var height = pdf.internal.pageSize.getHeight();

        var columnCount = 3;

        var rowHeight = (height - 2) / 4;
        var columnWidth = width / 3;

        pdf.setFontSize(7);

        var qrWidth = 1;

        var studentChunks = pdfCommonUtils.generateChunks(targetStudents || this.model.get('printStudents'), 12),
            totalChunks = studentChunks.length;

        for (var sc = 0; sc < totalChunks; sc++) {
            var studentIndex = 0;

            // get the number of rows on this page.
            var rows = pdfCommonUtils.generateChunks(studentChunks[sc], 3);

            // build grind layout with student qr and details.
            for (var i = 0; i < rows.length; i++) {
                var leftMargin = .9,
                    topMargin = 1.1,
                    heightOffsets = [0, .5, .6, .65],
                    columnOffsets = [0, .2, .4];

                var heightOffset = heightOffsets[i] * i;

                // adjust first row for avery sticker label buffer on
                //  physical paper.
                if (i === 0) {
                    heightOffset -= .4;
                }

                for (var c = 0; c < columnCount; c++) {
                    var student = studentChunks[sc][studentIndex];

                    if (!student) {
                        break;
                    }

                    var colOffset = (columnWidth * .9) * c + leftMargin + columnOffsets[c],
                        colHeightOffset = (rowHeight * .85) * i + topMargin + heightOffset,
                        textMargin = .15,
                        imageMargin = 1.1,
                        imageWrapMargin = .05,
                        topTextColOffset = colOffset + .625,
                        bottomTextColOffset = colOffset + .65,
                        studentNameLabel = this.getStudentLabelName(student);

                    // first row margin already calculated. offset is 0
                    pdf.text(
                        'Discovery Education',
                        topTextColOffset,
                        colHeightOffset,
                        'center'
                    );

                    // offset and add domain
                    colHeightOffset += textMargin;
                    pdf.text(
                        this.model.get('currentDomain'),
                        topTextColOffset,
                        colHeightOffset,
                        'center'
                    );

                    // offset and add QR Code
                    colHeightOffset += imageWrapMargin;
                    pdf.addImage(
                        student.qrAuth.qr_png_b64,
                        'PNG',
                        colOffset + .15, // bc of margins lets adjust 'center'
                        colHeightOffset,
                        qrWidth,
                        qrWidth,
                        student.id
                    );

                    if (studentNameLabel) {
                        // offset and add name, username, and expiry
                        colHeightOffset += imageMargin;
                        pdf.text(
                            studentNameLabel,
                            bottomTextColOffset,
                            colHeightOffset,
                            'center'
                        );
                        colHeightOffset += textMargin;
                    } else {
                        colHeightOffset += imageMargin;
                    }

                    pdf.text(
                        '(' + student.username + ')',
                        bottomTextColOffset,
                        colHeightOffset,
                        'center'
                    );
                    colHeightOffset += textMargin;
                    pdf.text(
                        student.qrAuth.localExpiryWithLabel,
                        bottomTextColOffset,
                        colHeightOffset,
                        'center'
                    );

                    studentIndex += 1;
                }
            }

            if (sc < totalChunks - 1) {
                pdf.addPage();
            }

            if (isZip) {
                zipFile.file(
                    folderName + '.pdf',
                    pdf.output('blob')
                );
            }
        }

        return isZip ? zipFile : pdf;
    };

    return function(isZip, model, forcePDFFormat) {
        this.model = model;
        this.buildLayout = buildTablePDF;

        $.each(Object.keys(pdfMixin), _.bind(function(_, key) {
            this[key] = pdfMixin[key];
        }, this))

        return this.buildTargetTypePDF(isZip, forcePDFFormat);
    };
});

